import Card from "components/card";
import BarChart from "components/charts/BarChart";
import { useEffect, useState } from "react";
import { MdBarChart } from "react-icons/md";

const WeeklyRevenue = (props) => {
  const [complaintStats, setComplaintStats] = useState([]);
  const [barChartOptionsComplaintStat, setBarChartOptionsComplaintStat] =
    useState({});

  useEffect(() => {
    setComplaintStats([
      {
        name: "Raised",
        data: [
          props?.complaint_data?.complaint_stat?.bnr_inactive_complaints || 0,
          props?.complaint_data?.complaint_stat?.enm_inactive_complaints || 0,
          props?.complaint_data?.complaint_stat?.misc_inactive_complaints || 0,
        ],
        color: "#FF5733", // Vibrant red
      },
      {
        name: "Pending",
        data: [
          props?.complaint_data?.complaint_stat?.bnr_hold_complaints || 0,
          props?.complaint_data?.complaint_stat?.enm_hold_complaints || 0,
          props?.complaint_data?.complaint_stat?.misc_hold_complaints || 0,
        ],
        color: "#FFC300", // Bright yellow
      },
      {
        name: "In Progress",
        data: [
          props?.complaint_data?.complaint_stat?.bnr_active_complaints || 0,
          props?.complaint_data?.complaint_stat?.enm_active_complaints || 0,
          props?.complaint_data?.complaint_stat?.misc_active_complaints || 0,
        ],
        color: "#28B463", // Fresh green
      },
      {
        name: "Resolved",
        data: [
          props?.complaint_data?.complaint_stat?.bnr_resolved_complaints || 0,
          props?.complaint_data?.complaint_stat?.enm_resolved_complaints || 0,
          props?.complaint_data?.complaint_stat?.misc_resolved_complaints || 0,
        ],
        color: "#3498DB", // Bright blue
      },
    ]);

    setBarChartOptionsComplaintStat({
      chart: {
        stacked: true,
        toolbar: {
          show: false,
        },
      },
      tooltip: {
        style: {
          fontSize: "12px",
          backgroundColor: "#000000",
        },
        theme: "dark",
      },
      xaxis: {
        categories: [
          `B & R (${
            props?.complaint_data?.complaint_stat?.bnr_all_complaints || 0
          })`,
          `E & M (${
            props?.complaint_data?.complaint_stat?.enm_all_complaints || 0
          })`,
          `Misc (${
            props?.complaint_data?.complaint_stat?.misc_all_complaints || 0
          })`,
        ],
        labels: {
          style: {
            colors: "#A3AED0",
            fontSize: "14px",
            fontWeight: "500",
          },
        },
      },
      yaxis: {
        show: false,
      },
      grid: {
        borderColor: "rgba(163, 174, 208, 0.3)",
      },
      fill: {
        colors: ["#FF5733", "#FFC300", "#28B463", "#3498DB"], // Updated color palette
      },
      plotOptions: {
        bar: {
          borderRadius: 10,
          columnWidth: "20px",
        },
      },
    });
  }, [props]);

  return (
    <Card extra="flex flex-col bg-white w-full rounded-3xl py-6 px-2 text-center">
      <div className="mb-auto flex items-center justify-between px-6">
        <h2 className="text-lg font-bold text-navy-700 dark:text-white">
          Complaints Stats
        </h2>
        <button className="!linear z-[1] flex items-center justify-center rounded-lg bg-lightPrimary p-2 text-brand-500 !transition !duration-200 hover:bg-gray-100 active:bg-gray-200 dark:bg-navy-700 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/10">
          <MdBarChart className="h-6 w-6" />
        </button>
      </div>

      <div className="md:mt-16 lg:mt-0">
        <div className="h-[250px] w-full xl:h-[350px]">
          {complaintStats.length && barChartOptionsComplaintStat && (
            <BarChart
              chartData={complaintStats}
              chartOptions={barChartOptionsComplaintStat}
            />
          )}
        </div>
      </div>
    </Card>
  );
};

export default WeeklyRevenue;
